module.exports = __webpack_public_path__ + "img/22.9.TU.bb999a0b.png";